import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormAlert, FormGroup, handleFormError, InputText } from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import Button from '@saucelabs/sl-component-buttons';


const ResetPasswordForm = ({ error, handleSubmit, submitting }) => (
  <form onSubmit={handleSubmit}>
    <FormAlert type="danger">{error}</FormAlert>
    <Row>
      <Col xs>
        <Field
          className="form-control"
          component={InputText}
          name="password"
          placeholder="New password"
          type="password"
        />
      </Col>
    </Row>
    <Row>
      <Col xs>
        <Field
          className="form-control"
          component={InputText}
          name="password_confirm"
          placeholder="Confirm new password"
          type="password"
        />
      </Col>
    </Row>
    <FormGroup>
      <Button
        block
        category="action"
        disabled={submitting}
        type="submit"
        withArrow
      >
        Reset Password
      </Button>
    </FormGroup>
  </form>
);

ResetPasswordForm.propTypes = {
  error: PropTypes.any,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

ResetPasswordForm.defaultProps = {
  error: undefined,
};

const ResetPasswordFormWrapper = reduxForm({
  form: 'resetPassword',
  onSubmit: (values, dispatch, formProps) => (
    formProps.resetPassword({ ...values, verifier: formProps.verifier })
      .catch(({ response }) => {
        handleFormError({
          dispatch,
          status: response.status,
          errors: {},
          message40x: (
            response.data.errors && Object.values(response.data.errors)[0]
          ) || response.data.message,
        });
      })
  ),
})(ResetPasswordForm);

ResetPasswordFormWrapper.propTypes = {
  resetPassword: PropTypes.func.isRequired,
};

export default ResetPasswordFormWrapper;
export { ResetPasswordForm, ResetPasswordFormWrapper };
